import { useIsMobile } from '@/hooks/use-mobile'
import { BuySellSplitProps, BuySellSplitData } from './BuySellSplitBase'
import { BuySellSplitMobile } from './BuySellSplitMobile'
import { BuySellSplitDesktop } from './BuySellSplitDesktop'

export const BuySellSplit = (props: BuySellSplitProps) => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <BuySellSplitMobile {...props} />
  }

  return <BuySellSplitDesktop {...props} />
}

export type { BuySellSplitData }
